import ShipAddressDisplay from 'components/RwdCheckout/Sections/ShipAddress/Display/ShipAddressDisplay';

export default ShipAddressDisplay;
